import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_ocr_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  ocr_scanned_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  point_start_date: fromDatatype.VarcharDatatypeInterface;
  point_end_date: fromDatatype.VarcharDatatypeInterface;
  res_txn_date: fromDatatype.VarcharDatatypeInterface;
  res_verification_status: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  res_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_quantity_base: fromDatatype.NumericDatatypeInterface;
  res_amount_txn: fromDatatype.MoneyDatatypeInterface;
  res_unit_price_txn: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_aat_claim_ocr_doc_line_RowClass implements bl_aat_claim_ocr_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  ocr_scanned_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  point_start_date: fromDatatype.VarcharDatatypeInterface;
  point_end_date: fromDatatype.VarcharDatatypeInterface;
  res_txn_date: fromDatatype.VarcharDatatypeInterface;
  res_verification_status: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  res_ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  res_ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  res_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_quantity_base: fromDatatype.NumericDatatypeInterface;
  res_amount_txn: fromDatatype.MoneyDatatypeInterface;
  res_unit_price_txn: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
